import CircularProgress from "@mui/material/CircularProgress";
import React from "react";

export const Component: React.FC<{}> = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100px",
      }}
    >
      <CircularProgress />
    </div>
  );
};

Component.displayName = "LoadingSpinner";
